export const externalLinks = {
  donateLink:
    "https://www.paypal.com/donate/?business=UKZU8WA37WEJU&no_recurring=0&item_name=Hi%2C+thanks+for+taking+the+time+to+donate.+%0AI+am+glad+that+one+of+my+apps+has+positively+impacted+your+life.+&currency_code=USD",

  discordLink: "https://discord.gg/dUztZxeRg7",
};
